import { render, staticRenderFns } from "./passwordChange.vue?vue&type=template&id=0c37514e&"
import script from "./passwordChange.vue?vue&type=script&lang=js&"
export * from "./passwordChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports